export default __webpack_public_path__ + "static/media/airplan2.1881b443.jpg";